import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/outline";

export default function NoMorePaymentDisclaimer() {
  const { t } = useTranslation("", {
    keyPrefix: "page.candidate.dashboard.payment",
  });
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <div className="w-full h-screen sm:min-h-[90vh] overflow-x-hidden bg-gray-50">
      <div className="w-full border-b border-gray-200 py-6 px-4 md:px-6">
        <div className="w-full flex justify-between  items-center">
          <h3 className="w-full mb-1 text-lg leading-6 text-gray-900 font-medium">
            {t("paymentSubscriptions")}
          </h3>
          {location.pathname !== "/student/dashboard/payment" && (
            <ArrowLeftIcon
              className="w-6 h-6 cursor-pointer ltr:rotate-180"
              onClick={() => navigate("/")}
            />
          )}
        </div>
      </div>
      <div className="w-full h-80 flex justify-center items-center">
        <h1 className="text-3xl">{t("noMorePayments")}</h1>
      </div>
    </div>
  );
}
